export const MIME_HEADER_FIELD = /^([\x21-\x39\x3b-\x7e]+):\s*(.*)$/;

export const hasMimeHeaderBlock = (raw: string): boolean => {
    const separator = raw.search(/\r?\n\r?\n/);
    if (separator < 0) return false;
    const lines = raw.slice(0, separator).split(/\r?\n/);
    return MIME_HEADER_FIELD.test(lines[0] || '')
        && lines.every((line) => MIME_HEADER_FIELD.test(line) || /^[ \t]/.test(line));
};
